/* This file is a copy of the existing file defined in the Settings app.           */
/* It displays OLDER API keys format. So, it is a temporary logic before creating  */
/* GKD API keys. */
import { constants, IconDownload } from '@klarna/bubble-ui';
import { hooks as i18nHooks } from 'mage-i18n';
import React, { useEffect, useState } from 'react';
const { Fonts, Colors } = constants;
const styles = {
    downloadText: {
        marginLeft: '10px'
    },
    downloadLink: Object.assign(Object.assign({}, Fonts.KLARNA_SANS_REGULAR), { borderRadius: '20px', height: 40, 
        // @ts-ignore: FIXME
        color: Colors.WHITE, padding: '5px 26px', display: 'flex', justifyContent: 'center', alignItems: 'center', textDecoration: 'none', width: '100%' })
};
function DownloadLocalDataLink({ id, data, type = 'text/plain', filename, onClick }) {
    const t = i18nHooks.useTranslator();
    const [hover, setHover] = useState(false);
    const [objectUrl, setObjectUrl] = useState('');
    function getObjectUrl({ data, type }) {
        // @ts-ignore: FIXME
        return window.webkitURL.createObjectURL(new window.Blob([data], { type }));
    }
    useEffect(() => {
        var _a, _b;
        if ((_a = window.webkitURL) === null || _a === void 0 ? void 0 : _a.revokeObjectURL) {
            window.webkitURL.revokeObjectURL(objectUrl);
            setObjectUrl(getObjectUrl({ data, type }));
            return (_b = window.webkitURL) === null || _b === void 0 ? void 0 : _b.revokeObjectURL(objectUrl);
        }
    }, [data, type]);
    return (React.createElement("a", { id: id, style: Object.assign(Object.assign({}, styles.downloadLink), { 
            // @ts-ignore: FIXME
            background: hover ? Colors.palette.Salmiak.hovered : Colors.palette.Salmiak }), onMouseOver: () => setHover(true), onMouseOut: () => setHover(false), onClick: onClick, href: objectUrl, download: filename, type: type },
        React.createElement(IconDownload, { color: 'white' }),
        React.createElement("span", { style: styles.downloadText }, t('settings-fe.pages.ApiCredentials.success.download'))));
}
export default DownloadLocalDataLink;
